import { render, staticRenderFns } from "./ChangeKioskBackground.vue?vue&type=template&id=85f29912&scoped=true&"
import script from "./ChangeKioskBackground.vue?vue&type=script&lang=js&"
export * from "./ChangeKioskBackground.vue?vue&type=script&lang=js&"
import style0 from "./ChangeKioskBackground.vue?vue&type=style&index=0&id=85f29912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f29912",
  null
  
)

export default component.exports